module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel03_770_280_zh-hant-1ae0ca88485db36c502be784f3637e7e.jpg";